// extracted by mini-css-extract-plugin
export var videoContainer = "_k2-0";
export var videoIframe = "_k2-3";
export var videoLink = "_k2-1";
export var videoOverlay = "_k2-4";
export var videoOverlayText = "_k2-5";
export var videoWrapper = "_k2-2";